import React, { useState, useEffect } from "react";
import axios from "axios";
import { CandidateService } from "../services/candidateService";
import { serverConfig } from "../services/server-config";
import default_profile_image from '../../src/components/content-panes/admin-candidate/candiate-info-nav/img/avatar.png';

export const BlobImage = ({ imageUrl }) => {
    const [blobUrl, setBlobUrl] = useState(null);

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const imgeUrl = `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${imageUrl}`;
                const response = await axios.get(imgeUrl, {
                    headers: CandidateService.getAuthHeader(),
                    responseType: 'blob',
                });
                // URL.createObjectURL(new Blob([res.data], { type: 'image/jpeg' }))
                const blob = new Blob([response.data], { type: response.headers["content-type"] });
                const url = URL.createObjectURL(blob);
                setBlobUrl(url);
            } catch (error) {
                console.error("Error fetching image:", error);
            }
        };

        fetchImage();
        return () => {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };
    }, [imageUrl]);

    return blobUrl ? <img src={blobUrl} alt="Fetched" className="candidate-profile-picture" /> : <img src={default_profile_image} alt="Fetched" className="candidate-profile-picture" />;
};
